// extracted by mini-css-extract-plugin
export default {"status":"Status_status__k9gN6","iconChange":"Status_iconChange__kMZXt","statusText":"Status_statusText__qksOw","select":"Status_select__hreQc"};